import React from 'react';
import { useState, useEffect } from 'react';
import { FormControl, FormControlLabel, Radio, RadioGroup, MenuItem, Select, Button, TextField, Grid, InputLabel } from '@mui/material';
import { saveAs } from 'file-saver';
import jsPDF from "jspdf";
import "jspdf-autotable";

function StockIssue() {
    const [categories, setCategories] = useState([]); //nabil 
    const [apiErrors, setApiErrors] = useState([]); //nabil
    const [selectedOption, setSelectedOption] = React.useState('all');
    const [selectedClass, setSelectedClass] = React.useState('');
    const [fromDate, setFromDate] = React.useState('');
    const [toDate, setToDate] = React.useState('');
    const [ddlClass, setDdlClass] = useState([]);
    const [schoolData, setSchoolData] = useState([]);
    const [reportData, setReportData] = useState(null);
    // Nabil is adding new code from here
    const [formData, setFormData] = useState({
        branchID: "",
        categoryID: "",
        itemName: "",
        itemCode: "",
        purchasedPrice: "",
        currentBalance: "",
        purchaseDate: null,
        vendorID: "",
        taxId: null,
        locationID: "",
        isDepreciable: false,
        usefulLifeYears: "",
        currentValue: "0",
        isAutoGenerateItemCode: true,
    });

    const addApiError = (errorMessage) => {
        setApiErrors((prev) => [...prev, errorMessage]);
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        console.log(`Field changed: ${name}, Value: ${value}, Type: ${type}`);
        setFormData((prev) => ({
            ...prev,
            [name]:
                type === "checkbox"
                    ? checked
                    : name === "taxId"
                        ? value === ""
                            ? null
                            : parseInt(value)
                        : value,
            ...(name === "isDepreciable" && !checked ? { usefulLifeYears: "" } : {}),
        }));

    };

    const fetchSchoolDetails = async () => {
        try {
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const token = sessionStorage.getItem('token');
            const response = await fetch(`${apiUrl}/FeeReport/GetSchoolName`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: token,
                },
                body: JSON.stringify({}),
            });
            if (!response.ok) {
                throw new Error(`Error fetching financial years: ${response.status}`);
            }
            const data = await response.json();
            setSchoolData(data);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchCategories = async () => {
        try {
            // setLoadingBarProgress(20);
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const response = await fetch(
                `${apiUrl}/inventory/Categories/GetMainCategory`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: sessionStorage.getItem("token"),
                    },
                    body: JSON.stringify({}),
                }
            );

            if (response.ok) {
                const data = await response.json();
                console.log("Categories fetched:", data);
                if (Array.isArray(data)) {
                    setCategories(data);
                    if (data.length === 0) {
                        addApiError("No categories available.");
                    }
                } else {
                    addApiError("Invalid category data received.");
                }
            } else {
                let errorMessage = `Failed to fetch categories (Status: ${response.status})`;
                try {
                    const errorData = await response.json();
                    errorMessage = errorData.message || errorMessage;
                } catch {
                    // Non-JSON response
                }
                addApiError(errorMessage);
                console.log("Failed to fetch categories, status:", response.status);
            }
        } catch (error) {
            console.error("Error fetching categories:", error);
            addApiError(`Error fetching categories: ${error.message}`);
        }
    };
    // Nabil added new code till here
    const handleOptionChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleClassChange = (event) => {
        setSelectedClass(event.target.value);
    };

    const handleFromDateChange = (event) => {
        setFromDate(event.target.value);
    };

    const handleToDateChange = (event) => {
        setToDate(event.target.value);
    };

    const handleClear = () => {
        setFormData({
            ...formData,
            categoryID: "",
        });
        setFromDate("");
        setToDate("");
        setReportData(null); // Clear report data if needed
    };


    const formatDate = (dateString) => {
        const parts = dateString.split('-'); // [YYYY, MM, DD]
        return `${parts[0]}/${parts[1]}/${parts[2]}`;
    };

   const getBase64FromImageUrl = async (imageUrl) => {
  try {
    const uniqueUrl = imageUrl + (imageUrl.includes("?") ? "&" : "?") + "t=" + Date.now();
    const res = await fetch(uniqueUrl, { mode: "cors", cache: "no-cache" });

    if (!res.ok) throw new Error(`HTTP ${res.status} - ${res.statusText}`);

    const blob = await res.blob();
    if (!blob.type.startsWith("image/")) throw new Error("URL does not point to an image");

    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => reader.result ? resolve(reader.result) : reject(new Error("Failed to read image"));
      reader.onerror = () => reject(new Error("Image read error"));
      reader.readAsDataURL(blob);
    });
  } catch (err) {
    console.error("Image conversion error:", err);
    return null;
  }
};


const handleSave = async () => {
  try {
    const url = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");

    const queryParams = new URLSearchParams({
      categoryId: formData.categoryID === "0" ? "" : formData.categoryID || "",
      startDate: fromDate ? formatDate(fromDate) : "",
      endDate: toDate ? formatDate(toDate) : "",
      format: "json",
    });

    const apiUrl = `${url}/InventoryReport/StockIssueReport?${queryParams.toString()}`;

    const response = await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Response error text:", errorText);
      alert("Error fetching Stock Issue Report");
      return;
    }

    const data = await response.json();

    if (data.msg === "Record Not Found") {
      alert("No records found");
      return;
    }

    setReportData(data);

    // Fetch school/branch details
    const branchResponse = await fetch(`${url}/Branch/GetBranch`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({}),
    });

    const branchData = await branchResponse.json();
    const school = Array.isArray(branchData) && branchData.length > 0 ? branchData[0] : {};

    // ---------- Generate PDF ----------
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    const contentWidth = pageWidth - 20;
    let margin = 10;
    let yPos = margin + 5;
const logoBase64 = school.bytLogo
  ? `data:image/jpeg;base64,${school.bytLogo}`
  : null;

let logoHeight = 0;

if (logoBase64) {
  try {
    const logoWidth = 30;
    const imgProps = doc.getImageProperties(logoBase64);
    const aspectRatio = imgProps.width / imgProps.height;
    logoHeight = logoWidth / aspectRatio;

    doc.addImage(logoBase64, "JPEG", margin + 5, yPos, logoWidth, logoHeight);
  } 

catch (error) {
    console.error("Error adding logo:", error);
    doc.setFontSize(8);
    doc.text("[Logo Error]", margin + 5, yPos + 12);
    logoHeight = 12;
  }
} else {
  doc.setFontSize(8);
  doc.text("[Logo Unavailable]", margin + 5, yPos + 12);
  logoHeight = 12;
}

// Estimate header block height
const schoolNameLines = doc.splitTextToSize(
  school.organisationName || "School Name",
  contentWidth - 35
);
const addressLines = doc.splitTextToSize(
  `Address: ${school.branchAddress || "Not Available"}`,
  contentWidth - 40
);

// Calculate tallest section height (either logo or text block)
const headerHeight = Math.max(
  logoHeight,
  5 + addressLines.length * 4 + 16 // approx text block height
);
      const verticalOffset = logoHeight > 0 ? logoHeight / 4 : 5;

// Now draw school name and address
doc.setFont("helvetica", "bold");
doc.setFontSize(25);
doc.text(schoolNameLines, margin + 40, yPos + verticalOffset + 2);

doc.setFont("helvetica", "normal");
doc.setFontSize(13);
doc.text(addressLines, margin + 40, yPos + verticalOffset + 9);

// Finalize yPos after header
yPos += headerHeight + 4;

// Draw horizontal line
doc.setDrawColor(0);
doc.setLineWidth(0.5);
doc.line(margin, yPos, pageWidth - margin, yPos);
yPos += 5;


    // Date Range
    const formattedFromDate = fromDate ? formatDate(fromDate, "dd/MM/yyyy") : "N/A";
    const formattedToDate = toDate ? formatDate(toDate, "dd/MM/yyyy") : "N/A";
   const dateRangeText =
  fromDate && toDate
    ? `(${formattedFromDate} - ${formattedToDate})`
    : "(All Records)";


    // Title
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("Stock Issue Report", pageWidth / 2, yPos + 10, { align: "center" });

    doc.setFontSize(12);
    doc.text(dateRangeText, pageWidth / 2, yPos + 16, { align: "center" });

    yPos += 22;

    // Table Data
    const tableBody = data.map((item) => [
      item.itemCode || "-",
      item.itemName || "-",
      item.branchName || "-",
      item.issuedQuantity || 0,
      item.issueDate || "-",
      item.issuedToType || "-",
      item.issuedTo || "-",
      item.returnStatus || "-",
    ]);

    doc.autoTable({
      startY: yPos,
      head: [[
        "Item Code",
        "Item Name",
        "Branch Name",
        "Issued Quantity",
        "Issue Date",
        "Issued To Type",
        "Issued To",
        "Return Status"
      ]],
      body: tableBody,
      theme: "grid",
      styles: {
        fontSize: 9,
        cellPadding: 3,
        overflow: "linebreak",
        halign: "left",
        valign: "middle",
      },
      headStyles: {
        fillColor: [217, 228, 232],
        textColor: [0, 0, 0],
        fontSize: 10,
        fontStyle: "bold",
        halign: "center",
      },
      margin: { left: 10, right: 10 },
    });

    // Open PDF
    const blob = doc.output("blob");
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl, "_blank");

  } catch (error) {
    console.error("Error generating report:", error);
    // alert(`Report generation failed: ${error.message}`);
    alert(`No Record Found! Try another date`);
  }
};








    const generateCSV = () => {
        if (!reportData || !Array.isArray(reportData) || reportData.length === 0) {
            console.error('No report data available');
            return;
        }

        let csvContent = '';
        const keys = Object.keys(reportData[0]);
        csvContent += keys.map(key => key.toUpperCase()).join(',') + '\n';
        reportData.forEach(item => {
            const values = keys.map(key => item[key]);
            csvContent += values.join(',') + '\n';
        });
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
        saveAs(blob, 'report.csv');
    };

    const buttonStyles = {
        generate: {
            background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
            borderRadius: "25px",
            padding: "10px 25px",
            width: "150px",
            boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
            transition: "all 0.3s ease",
            "&:hover": {
                background: "linear-gradient(45deg, #1976D2 30%, #1E88E5 90%)",
                transform: "translateY(-2px)",
                boxShadow: "0 5px 10px rgba(33, 203, 243, .4)",
            },
        },
        csv: {
            background: "linear-gradient(45deg, #f44336 30%, #ef5350 90%)",
            borderRadius: "25px",
            padding: "10px 25px",
            width: "150px",
            boxShadow: "0 3px 5px 2px rgba(244, 67, 54, .3)",
            transition: "all 0.3s ease",
            "&:hover": {
                background: "linear-gradient(45deg, #d32f2f 30%, #e53935 90%)",
                transform: "translateY(-2px)",
                boxShadow: "0 5px 10px rgba(244, 67, 54, .4)",
            },
        },
    };

    const selectStyles = {
        width: "250px",
        background: "linear-gradient(45deg, #ffffff 30%, #f5f5f5 90%)",
        borderRadius: "15px",
        boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
        transition: "all 0.3s ease",
        "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#2196F3",
            borderWidth: "2px",
        },
        "&:hover": {
            boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
            transform: "translateY(-2px)",
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#1976D2",
            },
        },
        "&.Mui-focused": {
            boxShadow: "0 6px 12px rgba(33, 150, 243, 0.3)",
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#21CBF3",
            },
        },
        "& .MuiSelect-select": {
            padding: "12px 16px",
            fontWeight: 500,
            color: "#333",
        },
    };

    // Function to format date to YYYY-MM-DD
    const getFormattedDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Set default dates
    useEffect(() => {
        const today = new Date(); // Current date: March 29, 2025
        const oneMonthAgo = new Date(today);
        oneMonthAgo.setMonth(today.getMonth() - 1); // Subtract 1 month

        setToDate(getFormattedDate(today)); // Default "To Date" to today
        setFromDate(getFormattedDate(oneMonthAgo)); // Default "From Date" to one month ago
        // Fetch data

        fetchCategories();
        fetchSchoolDetails();

    }, []);

    return (
        <Grid
            container
            spacing={2}
            justifyContent="center"
            style={{ margin: '0 auto', maxWidth: '600px' }} // reduced width for better centering
        >
            {/* Category Dropdown - Full width */}
            {/* <Grid item xs={12}>
                <FormControl fullWidth>
                    <InputLabel>Category</InputLabel>
                    <Select
                        name="categoryID"
                        value={formData.categoryID}
                        onChange={handleChange}
                        label="Category"
                        sx={{ ...selectStyles, width: "94%" }}
                    >
                       
                        <MenuItem value="0">All Categories</MenuItem>

                        {categories.length > 0 ? (
                            categories.map((category) => (
                                <MenuItem
                                    key={category.mainCategoryId}
                                    value={category.mainCategoryId.toString()}
                                >
                                    {category.mainCategoryName}
                                </MenuItem>
                            ))
                        ) : (
                            <MenuItem value="" disabled>No categories available</MenuItem>
                        )}
                    </Select>
                </FormControl>
            </Grid> */}


            {/* Date Fields - Side by Side */}
            <Grid item xs={12} sm={6}>
                <TextField
                    label="From Date"
                    type="date"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    sx={{ ...selectStyles }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="To Date"
                    type="date"
                    value={toDate}
                    onChange={handleToDateChange}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    sx={{ ...selectStyles }}
                />
            </Grid>

            {/* Buttons - Side by Side */}
            <Grid item xs={12} sm={6}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                    fullWidth
                    size="medium"
                    sx={{ ...buttonStyles.generate }}
                >
                    Generate Report
                </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
                <Button
                    variant="contained"
                    color="error"
                    onClick={generateCSV}
                    fullWidth
                    size="medium"
                    sx={{ ...buttonStyles.csv }}
                >
                    Download CSV
                </Button>
            </Grid>

            <Grid item xs={12}>
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleClear}
                    fullWidth
                    size="medium"
                    sx={{
                        borderRadius: "25px",
                        padding: "10px 25px",
                        width: "150px",
                        marginTop: "10px",
                        borderColor: "#6c757d",
                        color: "#6c757d",
                        transition: "all 0.3s ease",
                        "&:hover": {
                            backgroundColor: "#f0f0f0",
                            transform: "translateY(-2px)",
                            borderColor: "#5a6268",
                            color: "#5a6268",
                        },
                    }}
                >
                    Clear Fields
                </Button>
            </Grid>

        </Grid>


    );
}

export default StockIssue;
